export const VISUAL_PROFILE_MODE_TOGGLE = 'VISUAL_PROFILE_MODE_TOGGLE';

export const toggleProfileMode = () => ({
  type: VISUAL_PROFILE_MODE_TOGGLE
});



// WEBPACK FOOTER //
// ./src/actions/visual.js